import React from 'react';
import { FsDefaultInputProps } from 'ui-elements/form-elements/FsDefaultInput/FsDefaultInput';
import { Box } from '@material-ui/core';

import FsSimpleInput from '../FsDefaultInput';
import { getCcIcon } from './FsCreditCardInput.utils';
import { IconWrapper } from './FsCreditCardInput.style-elements';

type FsSimpleSelectProps = FsDefaultInputProps & {
  ccType?: string;
};

const FsCreditCardInput: React.FC<FsSimpleSelectProps> = ({
  children,
  ccType = '',
  ...otherInputProps
}) => {
  const ccIcon = getCcIcon(ccType, 30);
  return (
    <Box position="relative">
      <FsSimpleInput {...otherInputProps} />
      <IconWrapper>{ccIcon}</IconWrapper>
    </Box>
  );
};

export default FsCreditCardInput;
